import styled from 'styled-components';

export const PickerWrapper = styled.div`
  .ant-picker {
    visibility: hidden;
  }
`;
